import React from "react";
import { Link } from "react-router-dom";
import { lang } from "../../../middleware/lang";

type Props = {
  active: string;
};

const tabs = [
  {
    key: "ingredients",
    link: "/inventory",
    labelEs: "Ingredientes",
    labelEn: "Ingredients",
  },
  {
    key: "recipes",
    link: "/inventory/recipes",
    labelEs: "Recetas",
    labelEn: "Recipes",
  },
  // { key: "purchases", link: "/inventory/purchases", labelEs: "Compras", labelEn: "Purchases" },
  // { key: "suppliers", link: "/inventory/suppliers", labelEs: "Proveedores", labelEn: "Suppliers" },
  {
    key: "counts",
    link: "/inventory/counts",
    labelEs: "Conteos",
    labelEn: "Counts",
  },
  {
    key: "waste",
    link: "/inventory/waste",
    labelEs: "Merma",
    labelEn: "Waste",
  },
  {
    key: "production",
    link: "/inventory/production",
    labelEs: "Producción",
    labelEn: "Production",
  },
  {
    key: "alerts",
    link: "/inventory/alerts",
    labelEs: "Alertas",
    labelEn: "Alerts",
  },
  {
    key: "food-cost",
    link: "/inventory/food-cost",
    labelEs: "Costo",
    labelEn: "Cost",
  },
  {
    key: "reports",
    link: "/inventory/reports",
    labelEs: "Reportes",
    labelEn: "Reports",
  },
  {
    key: "movements",
    link: "/inventory/movements",
    labelEs: "Movimientos",
    labelEn: "Movements",
  },
];

const InventoryNav: React.FC<Props> = ({ active }) => (
  <ul className="nav nav-tabs mb-3">
    {tabs.map((tab) => (
      <li className="nav-item" key={tab.key}>
        <Link
          to={tab.link}
          className={`nav-link ${active === tab.key ? "active" : ""}`}
        >
          {lang(tab.labelEs, tab.labelEn)}
        </Link>
      </li>
    ))}
  </ul>
);

export default InventoryNav;
